var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95734 5.07272C5.95734 5.49214 5.61733 5.83215 5.19791 5.83215M5.95734 5.07272C5.95734 4.6533 5.61733 4.31329 5.19791 4.31329M5.95734 5.07272H5.19791M5.19791 5.83215C4.77849 5.83215 4.43848 5.49214 4.43848 5.07272M5.19791 5.83215V5.07272M4.43848 5.07272C4.43848 4.6533 4.77849 4.31329 5.19791 4.31329M4.43848 5.07272H5.19791M5.19791 4.31329V5.07272M18.181 18.676C18.181 12.9747 5.81934 12.9747 5.81934 18.676C10.6469 18.676 13.3535 18.676 18.181 18.676ZM12.0002 12.4952C13.707 12.4952 15.0906 11.1115 15.0906 9.40475C15.0906 7.69796 13.707 6.31433 12.0002 6.31433C10.2934 6.31433 8.90976 7.69796 8.90976 9.40475C8.90976 11.1115 10.2934 12.4952 12.0002 12.4952ZM5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPage);
export default __webpack_public_path__ + "static/media/user_page.d763919ac3b3d35db06541315dca6662.svg";
export { ForwardRef as ReactComponent };